import { ADD_TO_BASKET, ADD_TO_BASKET_ERROR, ADD_TO_BASKET_SUCCESS } from "core-web/state/models/Basket/constants";

import tracking from "core-web/components/Tracking";
import Events from "core-web/libs/Events";
import { BasketEvents } from "core-web/libs/Events/constants";
import AddToBasket from "core-web/libs/GrebbCommerceAPI/Basket/AddToBasket";
import { acquireMutex } from "core-web/state";
import createBasket from "core-web/state/models/Basket/dispatches/createBasket";
import getBasket from "core-web/state/models/Basket/dispatches/getBasket";
import updateBasketItem from "core-web/state/models/Basket/dispatches/updateBasketItem";
import getBasketId from "core-web/state/models/Basket/utils/getBasketId";
import getItemByPartNo from "core-web/state/models/Basket/utils/getItemByPartNo";
import setBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setBasketItemsAmountCookie";
import setUniqueBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setUniqueBasketItemsAmountCookie";
import store from "core-web/state/store";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import addMemberPromotions from "./addMemberPromotions";
import getCheckout from "./getCheckout";

export const addToBasket =
    (partNo, quantity, pricelistId = null, infos = [], comment = "", manualPrice) =>
    async (dispatch, getState) => {
        let basketId = await getBasketId();
        let basket = getState().basket;
        const pageType = getState().page.type;
        const eventId = tracking.getUniqueId();
        const basketWasEmpty = !basket.items?.length;

        let basketItemId = null;
        let newQuantity = null;

        if (!basketId) {
            const basketResponse = await createBasket();
            basket = basketResponse?.data;
        } else if (!basket.isFetched) {
            const basketResponse = await getBasket();
            if (basketResponse?.basketId) {
                basket = basketResponse;
                basketId = basketResponse.basketId;
            } else if (basketResponse?.data?.id) {
                basket = basketResponse.data;
                basketId = basket.id;
            }
        }

        const savedAutomatedDiscounts = getState().products.automatedDiscounts;

        if (
            Object.keys(savedAutomatedDiscounts).some((automatedDiscountPartNo) => automatedDiscountPartNo === partNo)
        ) {
            manualPrice = savedAutomatedDiscounts[partNo].discountPriceExVat;
        }

        const mutexLock = await acquireMutex("basket.getBasket");

        basket.items?.length &&
            basket.items.forEach((item) => {
                // We need to check if there is a parent_line_no here, otherwise we might try to update promotions or packages, which we shouldn't.
                if (item.parent_line_no === null && item.part_no === partNo) {
                    basketItemId = item.id;
                    newQuantity = parseInt(quantity, 10) + parseInt(item.quantity, 10);
                }
            });

        if (basketItemId) {
            mutexLock();

            return updateBasketItem(basketId, partNo, basketItemId, newQuantity, pricelistId, "add", manualPrice);
        }

        dispatch({ type: ADD_TO_BASKET });

        try {
            const response = await AddToBasket(
                basketId,
                partNo,
                quantity,
                pricelistId,
                infos,
                comment,
                eventId,
                manualPrice,
            );

            const basketItemsTree = buildCartProductTree(response.data.items);
            const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
            setBasketItemsAmountCookie(basketItemsCount);
            setUniqueBasketItemsAmountCookie(basketItemsTree.length);

            dispatch({
                type: ADD_TO_BASKET_SUCCESS,
                items: basketItemsTree,
                info: response.data.info || [],
                summary: response.data.format.summary,
                promotions: response.data.applied_promotions,
            });

            Events.trigger(BasketEvents.UPDATED);
            Events.trigger(BasketEvents.PRODUCT_ADDED, {
                basketId,
                // This function might not always return the correct item, see function comment for more details
                item: { ...getItemByPartNo(partNo, basketItemsTree), quantity },
                eventId,
            });

            mutexLock();

            if (basketWasEmpty && pageType === "storm_checkout") {
                getCheckout();
            }

            const activeMemberPromotions = getState().basket.activeMemberPromotions;
            if (activeMemberPromotions?.length) {
                const activeMemberPromotionIds = activeMemberPromotions.map((promotion) => promotion.id);
                addMemberPromotions(activeMemberPromotionIds);
            }

            return response;
        } catch (e) {
            dispatch({ type: ADD_TO_BASKET_ERROR });

            mutexLock();

            throw e;
        }
    };

export default (partNo, quantity, pricelistId, infos, comment, manualPrice) =>
    store.dispatch(addToBasket(partNo, quantity, pricelistId, infos, comment, manualPrice));
